import React, { useContext } from 'react';
import SmsFillIcon from 'components/lib/icons/sms_fill_icon';
import FloorboardRow from './floorboard_row';
import LiveboardContext from 'components/liveboards/contexts/liveboard_context.jsx';

export default function SMSRow() {
  const { channel, sla } = useContext(LiveboardContext);

  const stats = channel.sms;
  const smsSla = sla.sms;
  return (
    <FloorboardRow
      newItems={stats.currentNewSms}
      activeItems={stats.currentOpenSms}
      currentWait={stats.currentWait}
      sla={smsSla}
      activeLabel="Active SMS"
      newLabel="New SMS"
      waitLabel="Oldest Unanswered SMS"
      icon={<SmsFillIcon />}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/floorboard/sms_row.jsx